export interface MasjidOption {
  _id: string;
  masjidName: string;
  address: string;
  contact: string;
}
export enum OwnerType {
  ORGANIZATION = "ORGANIZATION",
  INDIVIDUAL = "INDIVIDUAL",
  MASJID = "MASJID",
}

export interface SettingsState {
  prayerMethod: number | null;
  juristic: string | null;
  sunriseAdjustment: number;
  higherAltitudeMethod: string;
  hijriAdjustment: number;
}

export enum SETTINGS_FIELD {
  PRAYER_METHOD = "prayerMethod",
  JURISTIC = "juristic",
  SUNRISE_ADJUSTMENT = "sunriseAdjustment",
  HIGHER_ALTITUDE_METHOD = "higherAltitudeMethod",
  HIJRI_ADJUSTMENT = "hijriAdjustment",
}

export type SettingsActionType = {
  type: string;
  payload: {
    field: keyof typeof SETTINGS_FIELD;
    value: any;
  };
};
export const DEFAULT_JURISTIC = "Manual";
export const JURISTIC_STORED = {
  HANAFI: "Manual",
  OTHER: "Maliki/Shafi'i/Hanbali",
} as const;
export const JURISTIC_DISPLAY = {
  HANAFI: "Hanafi",
  OTHER: "Maliki/Shafi'i/Hanbali",
} as const;
export const DEFAULT_METHOD_ID = 2; 


export enum HigherAltitudeMethod {
  // NONE = "none",
  MIDDLE_OF_NIGHT = "middle",
  ONE_SEVENTH = "one-seventh",
  ANGLE_BASED = "angle",
}

// Enum for display values (used in UI)
export enum HigherAltitudeMethodDisplay {
  // NONE = "None",
  MIDDLE_OF_NIGHT = "Middle Of The Night Method",
  ONE_SEVENTH = "One-Seventh Of The Night Method",
  ANGLE_BASED = "Angled-Based Method",
}